import React, {useState} from "react";
import Chart from 'react-apexcharts'
import {getMessageHistoryTimeLineCounting} from "../../api/MessageAPI";
import {Button, Checkbox, Collapse, Input, List, ListItem, Radio} from "@material-tailwind/react";

export default function TimeLineMonitor() {

  const [timeline, setTimeline] = useState('second')
  const [detailSearchOpen, setDetailSearchOpen] = useState(false)
  const [search, setSearch] = useState({
    'taskId': '9ca072b4-f01b-4495-a669-5ae8ad98778a',
    'jobType': new Set(),
    'roundNum': '',
    'result': new Set()
  })
  const [searchResult, setSearchResult] = useState({'datetime': [], 'count': []})

  const jobTypes = ["TRAINING", "EVALUATION", "TEST"]
  const results = ["Init", "Success", "Fail"]

  const taskChart = {
    series: [{
      name: '',
      data: searchResult['count']
    }],
    options: {
      chart: {
        type: 'bar',
        zoom: {
          enabled: true,
          type: 'x',
          autoScaleYaxis: false,
          zoomedArea: {
            fill: {
              color: '#6cdeff',
              opacity: 0.4
            },
            stroke: {
              color: '#0D47A1',
              opacity: 0.4,
              width: 1
            }
          }
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: 'center',
          },
        }
      },
      dataLabels: {
        enabled: true,
        offsetY: -10,
        style: {
          fontSize: '14px',
          colors: ["#304758"]
        }
      },
      xaxis: {
        categories: searchResult['datetime'],
        position: 'bottom',
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        crosshairs: {
          fill: {
            type: 'gradient',
            gradient: {
              colorFrom: '#D8E3F0',
              colorTo: '#BED1E6',
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            }
          }
        },
        tooltip: {
          enabled: true,
        },
        tickPlacement: 'on'
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false
        }
      }
    },
  }

  const toggleDetailSearchOpen = () => setDetailSearchOpen((cur) => !cur)

  const convertDateTimeFormat = (date) => {
    return date.toISOString().replace("T", " ").substring(0, 19);
  }

  const fillDateTime = (start, end) => {
    let fillDateTimeList = []

    const a = new Date(start)
    const b = new Date(end)

    let timeStep = b - a
    if (timeline === 'second') {
      timeStep /= 1000
    } else if (timeline === 'minute') {
      timeStep /= 1000 * 60
    } else if (timeline === 'hour') {
      timeStep /= 1000 * 60 * 60
    }
    timeStep = Math.floor(timeStep) + 1

    // fill all datetime
    for (let i = 0; i < timeStep; i++) {
      let dateTimeItem = new Date(a.valueOf())

      if (timeline === 'second') {
        dateTimeItem = new Date(dateTimeItem.setSeconds(dateTimeItem.getSeconds() + i))
      } else if (timeline === 'minute') {
        dateTimeItem = new Date(dateTimeItem.setMinutes(dateTimeItem.getMinutes() + i))
      } else if (timeline === 'hour') {
        dateTimeItem = new Date(dateTimeItem.setHours(dateTimeItem.getHours() + i))
      }

      // convert kokr timezone
      dateTimeItem = new Date(dateTimeItem.setHours(dateTimeItem.getHours() + 9))

      fillDateTimeList.push(convertDateTimeFormat(dateTimeItem))
    }

    return fillDateTimeList
  }

  const handleSearch = (e) => {
    e.preventDefault()
    getMessageHistoryTimeLineCounting(search, timeline)
      .then(res => {
        if (Object.keys(res.data.data).length > 0) {
          let searchedData = Object.entries(res.data.data)
            .sort((a, b) => new Date(a[0]) - new Date(b[0]))

          let searchedDataSet = searchedData.reduce((acc, cur) => {
            acc[cur[0]] = cur[1]
            return acc
          }, {})

          let fillData = fillDateTime(searchedData[0][0], searchedData[searchedData.length - 1][0])

          let datetime = []
          let count = []

          fillData.forEach(item => {
            datetime.push(item)
            if (item in searchedDataSet) {
              count.push(searchedDataSet[item])
            } else {
              count.push(0)
            }
          })

          setSearchResult({'datetime': datetime, 'count': count})
        } else {
          setSearchResult({'datetime': [], 'count': []})
        }
      })
  }

  const handleCheckboxChange = (searchField, item, checked) => {
    if (checked) {
      search[searchField].add(item)
    } else {
      search[searchField].delete(item)
    }
    setSearch({...search, [searchField]: search[searchField]})
  }

  return (
    <>
      <form onSubmit={handleSearch}>
        <div>
          <div className="flex gap-4">
            <div className="w-96">
              <Input
                label="Task ID"
                defaultValue={search['taskId']}
                onChange={e => setSearch({...search, 'taskId': e.target.value})}
              />
            </div>
            <div>
              <Input
                label="Round"
                onChange={e => setSearch({...search, 'roundNum': e.target.value})}
              />
            </div>
            <div>
              <Button
                className="rounded-full"
                color={"cyan"}
                onClick={handleSearch}
                type={"submit"}
              >
                Search
              </Button>
            </div>
          </div>

          <div className="my-3 text-center">
            <Button size="sm" variant="outlined" onClick={toggleDetailSearchOpen} fullWidth>⇓</Button>
          </div>
          <Collapse open={detailSearchOpen}>
            <div className="grid grid-cols-1 2xl:grid-cols-3 gap-4">
              <div className="my-2 border-2 rounded-lg">
                <p className="text-center font-bold">
                  Time Line
                </p>
                <div className="flex justify-center gap-4" onChange={e => setTimeline(e.target.value)}>
                  <Radio name="type"
                         label="hour"
                         value="hour"/>
                  <Radio name="type"
                         label="minute"
                         value="minute"/>
                  <Radio name="type"
                         label="second"
                         value="second"
                         defaultChecked/>
                </div>
              </div>

              <div className="my-2 border-2 rounded-lg">
                <p className="text-center font-bold">
                  Job Type (No select is all select)
                </p>
                <List className="flex-row justify-center p-0 mr-2">
                  {
                    jobTypes.map(item => {
                      return <label key={item}>
                        <ListItem className="p-0">
                          <Checkbox
                            label={item}
                            value={item}
                            onChange={e => handleCheckboxChange('jobType', e.target.value, e.target.checked)}/>
                        </ListItem>
                      </label>
                    })
                  }
                </List>
              </div>

              <div className="my-2 border-2 rounded-lg">
                <p className="text-center font-bold">
                  Result (No select is all select)
                </p>
                <List className="flex-row justify-center p-0">
                  {
                    results.map(item => {
                      return <label key={item}>
                        <ListItem className="p-0">
                          <Checkbox
                            label={item}
                            value={item}
                            onChange={e => handleCheckboxChange('result', e.target.value, e.target.checked)}/>
                        </ListItem>
                      </label>
                    })
                  }
                </List>
              </div>
            </div>
          </Collapse>

        </div>
      </form>

      <div className="h-[calc(100vh-400px)]">
        <Chart
          options={taskChart.options}
          series={taskChart.series}
          type='bar'
          height="100%"
        />
      </div>
    </>
  )
}
